module.exports = __webpack_public_path__ + "img/burgir-menu.4437866f.svg";